import { fetchMemberCheckIdExits } from '@module/apis/client-side/member';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import catchAllErrors from '@module/utils/catchAllErrors';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useState } from 'react';
interface CheckIdContainterProps {
  goNextStep: () => void;
  setPwTargetId: (value: string) => void;
}
function CheckIdContainter({
  goNextStep,
  setPwTargetId
}: CheckIdContainterProps) {
  const pushModal = useModalStore(state => state.pushModal);
  const popModal = useModalStore(state_0 => state_0.popModal);
  const [id, setId] = useState('');
  const handleCheckClick = async () => {
    if (!id) {
      pushModal({
        type: MODAL_TYPE_PC.CONFIRM_MODAL,
        id: 'CheckIdContainter',
        options: {
          description: '아이디를 입력해 주세요.',
          onClose: popModal
        }
      });
      return;
    }
    try {
      const res = await fetchMemberCheckIdExits({
        id
      });
      if (res.result) {
        setPwTargetId(id);
        goNextStep();
      }
    } catch (err) {
      if (err instanceof BaseHttpResponseError) {
        catchAllErrors(err.message, () => {
          pushModal({
            type: MODAL_TYPE_PC.CONFIRM_MODAL,
            id: 'CheckIdContainter',
            options: {
              description: err.message,
              onClose: popModal
            }
          });
        });
      }
    }
  };
  return <div className='flex flex-col items-center pb-40'>
      <div className='flex w-full items-center border-t-[2px] border-t-borderBg10 border-b-[1px]'>
        <span className='flex h-[58px] w-[180px] items-center px-[15px] text-colorFg18 '>아이디</span>
        <input value={id} className='ml-12 h-10 w-[300px] rounded-lg border border-borderBg11 px-[17px] text-baseFg outline-none' onChange={e => setId(e.currentTarget.value)} placeholder='아이디 입력' />
      </div>
      <div className='mt-20'>
        <BaseButton variant='primary' size='md' onClick={handleCheckClick}>
          비밀번호 찾기
        </BaseButton>
      </div>
    </div>;
}
export default CheckIdContainter;